import axios from "../../axios";
import store from "@/store/store.js";
const header = (token) => {
  return {
    headers: {
        Authorization: "Bearer "+ token
    }
  }
}

export default {
  async getAllTenants(token, filterUsers) {
    axios.defaults.baseURL = process.env.VUE_APP_API_BASE_URL + `/api/tenant/${filterUsers}`;
    try {
      let tenants = await axios.get('', header(token));
      return tenants['data'];
    } catch (Exception) {
      throw Exception;
    }
  },
  async fetchPaginatedTenants(token, filterUsers, page = 1, limit = 4, search = '', sortName = 'id', sortType = 'DESC', strictFqdn = false) {
    axios.defaults.baseURL = process.env.VUE_APP_API_BASE_URL + `/api/tenant/paginated`;
    try {
      return await axios.post('', {
        'filter_users': filterUsers,
        'pagination_page': page,
        'pagination_limit': limit,
        'search': search,
        'sort_name': sortName,
        'sort_type': sortType,
        'strict_fqdn': strictFqdn
      }, header(token));
    } catch (Exception) {
      throw Exception;
    }
  },
  async addTenant(token, name, cnpj, features, template, pool, userLimit, partnerId, plan, ticketLimit) {
    axios.defaults.baseURL = process.env.VUE_APP_API_BASE_URL + '/api/tenant';
    try {
      return await axios.post('', { 'name': name, 'cnpj': cnpj, 'features': features, 'template': template, 'pool': pool, 'userLimit': userLimit, 'plan': plan, 'ticketLimit': ticketLimit, 'partnerId': partnerId}, header(token));
    } catch (Exception) {
      throw Exception;
    }
  },
  async deleteTenant(data, token) {
    axios.defaults.baseURL = process.env.VUE_APP_API_BASE_URL + '/api/tenant/delete';
    try {
      return await axios.post('', {
        id: data.id,
        reason: data.reason
      }, header(token));
    } catch (Exception) {
      throw Exception;
    }
  },
  async getOrders(startAt, finishAt, byDay, token) {
    axios.defaults.baseURL = process.env.VUE_APP_API_BASE_URL + `/api/tenant/sheets/orders?startAt=${startAt}&finishAt=${finishAt}&byDay=${byDay}`;
    try {
      return await axios.get('', header(token));
    } catch (Exception) {
      throw Exception;
    }
  },
  async getConsolidatedOrders(params, token) {
    const query = new URLSearchParams({
      startAt: params.startAt,
      finishAt: params.finishAt,
      websiteIds: params.websiteIds || '',
      statusFilter: params.statusFilter || 'all',
      page: String(params.page || 1),
      limit: String(params.limit || 20),
      export: params.export ? 'true' : 'false',
    }).toString();
    axios.defaults.baseURL = process.env.VUE_APP_API_BASE_URL + `/api/tenant/consolidated-orders?${query}`;
    try {
      return await axios.get('', header(token));
    } catch (Exception) {
      throw Exception;
    }
  },
  async getAttendances(startAt, finishAt, websiteId, estimation, token, attendance = false) {
    axios.defaults.baseURL = process.env.VUE_APP_API_BASE_URL + `/api/tenant/sheets/attendances?startAt=${startAt}&finishAt=${finishAt}&websiteId=${websiteId}&estimation=${estimation}&attendance=${attendance}`;
    try {
      return await axios.get('', header(token));
    } catch (Exception) {
      throw Exception;
    }
  },
  async sendAttendancesToMail(startAt, finishAt, websiteId, estimation, email, token) {
    axios.defaults.baseURL = process.env.VUE_APP_API_BASE_URL + '/api/tenant/sheets/attendances-email';
    try {
      return await axios.post('', {
        startAt: startAt,
        finishAt: finishAt,
        websiteId: websiteId,
        estimation: estimation,
        email: email
      }, header(token));
    } catch (Exception) {
      throw Exception;
    }
  },
  async countPerPool(filterByEnvironment, token) {
    axios.defaults.baseURL = process.env.VUE_APP_API_BASE_URL + `/api/countPerPool?filterByEnvironment=${filterByEnvironment}`;
    try {
      return await axios.get('', header(token));
    } catch (Exception) {
      throw Exception;
    }
  },
  async getInstanceLogs(startAt, finishAt, token) {
    axios.defaults.baseURL = process.env.VUE_APP_API_BASE_URL + `/api/tenant/sheets/instance_logs?startAt=${startAt}&finishAt=${finishAt}`;
    try {
      return await axios.get('', header(token));
    } catch (Exception) {
      throw Exception;
    }
  },
  async getReasons(token, startAt, finishAt, tenancyId, reasonId) {
    axios.defaults.baseURL = process.env.VUE_APP_API_BASE_URL + `/api/tenant/sheets/reasons?startAt=${startAt}&finishAt=${finishAt}&tenancyId=${tenancyId}&reasonId=${reasonId}`;
    try {
      return await axios.get('', header(token));
    } catch (Exception) {
      throw Exception;
    }
  },
  async restoreTenant(hostnameId, token, reason) {
    axios.defaults.baseURL = process.env.VUE_APP_API_BASE_URL + '/api/tenant/restore';
    try {
      return await axios.post('', {'id': hostnameId, 'reason': reason}, header(token));
    } catch (Exception) {
      throw Exception;
    }
  },
  async updateTenantPlan(token, hostnameId, plan, user, ticket, tenantName = null, keepUserIds = []) {
    axios.defaults.baseURL = process.env.VUE_APP_API_BASE_URL + '/api/tenant/set-plan';
    try {
      return await axios.post('', {'id': hostnameId, 'plan': plan, 'user': user, 'ticket': ticket, 'tenantName': tenantName, 'keepUserIds': keepUserIds}, header(token));
    } catch (Exception) {
      throw Exception;
    }
  },
  async updatePlanExpiration(token, hostnameId, planExpirationDate, supportLink) {
    axios.defaults.baseURL = process.env.VUE_APP_API_BASE_URL + '/api/tenant/set-plan-expiration';
    try {
      return await axios.post('', {'id': hostnameId, 'plan_expiration_date': planExpirationDate, 'support_link': supportLink}, header(token));
    } catch (Exception) {
      throw Exception;
    }
  },
  async resetExpirationPopup(token, hostnameId) {
    axios.defaults.baseURL = process.env.VUE_APP_API_BASE_URL + '/api/tenant/reset-expiration-popup';
    try {
      return await axios.post('', {'id': hostnameId}, header(token));
    } catch (Exception) {
      throw Exception;
    }
  },
  async getTenantUsers(token, tenantName) {
    axios.defaults.baseURL = process.env.VUE_APP_API_BASE_URL + '/api/tenant/list-users';
    try {
      return await axios.get('',  {
        params: { tenantName },
        ...header(token)
      });
    } catch (Exception) {
      throw Exception;
    }
  },
  async getFeatures(tenantName, token) {
    axios.defaults.baseURL = process.env.VUE_APP_API_BASE_URL + '/api/tenant/feature';
    try {
      return await axios.get('',  {
        params: {
          tenantName: tenantName
        },
        ...header(token)
      });
    } catch(Exception) {
      console.log(Exception);
      throw Exception;
    }
  },
  async syncAnalytics(fromDate, toDate, forceUpdate, tenantName, token) {
    axios.defaults.baseURL = process.env.VUE_APP_API_BASE_URL + '/api/tenant/syncAnalytics';
    try {
      return await axios.get('',  {
        params: {
          forceUpdate: forceUpdate,
          tenantName: tenantName,
          fromDate: fromDate,
          toDate: toDate,
        },
        ...header(token)
      });
    } catch(Exception) {
      console.log(Exception);
      throw Exception;
    }
  },
  async updateFeatures(features, tenantName, token) {
    store.dispatch('setShowLoadingOverlay', false);
    axios.defaults.baseURL = process.env.VUE_APP_API_BASE_URL + '/api/tenant/feature';
    try {
      const promises = [];
      Object.entries(features).forEach(([option, enabled]) => {
        const promise = axios.post(
          '',
          {option: option, enabled: enabled, tenantName: tenantName},
          header(token)
        );
        promises.push(promise);
      });

      const response = await Promise.all(promises);
      store.dispatch('setShowLoadingOverlay', true);
      return response;
    } catch (Exception) {
      throw Exception;
    }
  },
  async generateCampaignStatusWebhook(startAt, finishAt, type, tenant, token) {
    store.dispatch('setShowLoadingOverlay', false);
    axios.defaults.baseURL = process.env.VUE_APP_API_BASE_URL + '/api/tenant/generate-campaign-status-webhook';
    try {
      const promises = [];
      Object.entries(type).forEach(([type, value]) => {
        if (value) {
          const promise = axios.get('',  {
            params: {
              tenantName: tenant,
              finishAt: finishAt,
              startAt: startAt,
              type: type
            },
            ...header(token)
          });
          promises.push(promise);
        }
      });

      const response = await Promise.all(promises);
      store.dispatch('setShowLoadingOverlay', true);
      return response;
    } catch(Exception) {
      console.log(Exception);
      throw Exception;
    }
  },
  async getDistributionStatus(startAt, finishAt, tenantName, token) {
    axios.defaults.baseURL = process.env.VUE_APP_API_BASE_URL + '/api/tenant/get-distribution-status';
    try {
      return await axios.post('', {
        startAt: startAt,
        finishAt: finishAt,
        tenantName: tenantName
      }, header(token));
    } catch(Exception) {
      console.log(Exception);
      throw Exception;
    }
  },
  async generateAttendanceProductivityReport(fromDate, toDate, selectedUsers, email, tenantName, token) {
    axios.defaults.baseURL = process.env.VUE_APP_API_BASE_URL + '/api/tenant/generate-attendance-productivity-report';
    try {
      return await axios.post('', {
        fromDate: fromDate,
        toDate: toDate,
        selectedUsers: selectedUsers,
        email: email,
        tenantName: tenantName
      }, header(token));
    } catch(Exception) {
      console.log(Exception);
      throw Exception;
    }
  },
  async generateCampaignProductivityReport(fromDate, toDate, type, email, tenantName, token) {
    axios.defaults.baseURL = process.env.VUE_APP_API_BASE_URL + '/api/tenant/generate-campaign-productivity-report';
    try {
      return await axios.post('', {
        fromDate: fromDate,
        toDate: toDate,
        type: type,
        email: email,
        tenantName: tenantName
      }, header(token));
    } catch(Exception) {
      console.log(Exception);
      throw Exception;
    }
  },
  async generateOperatorProductivityReport(fromDate, toDate, selectedUsers, email, tenantName, token) {
    axios.defaults.baseURL = process.env.VUE_APP_API_BASE_URL + '/api/tenant/generate-operator-productivity-report';
    try {
      return await axios.post('', {
        fromDate: fromDate,
        toDate: toDate,
        selectedUsers: selectedUsers,
        email: email,
        tenantName: tenantName
      }, header(token));
    } catch(Exception) {
      console.log(Exception);
      throw Exception;
    }
  },
  async generateOrderProductivityReport(fromDate, toDate, email, tenantName, token, seeDetails = false) {
    axios.defaults.baseURL = process.env.VUE_APP_API_BASE_URL + '/api/tenant/generate-order-productivity-report';
    try {
      return await axios.post('', {
        fromDate: fromDate,
        toDate: toDate,
        email: email,
        tenantName: tenantName,
        seeDetails: seeDetails
      }, header(token));
    } catch(Exception) {
      console.log(Exception);
      throw Exception;
    }
  },
  async generateLoginFailuresProductivityReport(fromDate, toDate, selectedUsers, email, tenantName, token) {
    axios.defaults.baseURL = process.env.VUE_APP_API_BASE_URL + '/api/tenant/generate-login-failures-productivity-report';
    try {
      return await axios.post('', {
        fromDate: fromDate,
        toDate: toDate,
        selectedUsers: selectedUsers,
        email: email,
        tenantName: tenantName
      }, header(token));
    } catch(Exception) {
      console.log(Exception);
      throw Exception;
    }
  },
  async generateGradeProductivityReport(fromDate, toDate, selectedUsers, email, tenantName, token) {
    axios.defaults.baseURL = process.env.VUE_APP_API_BASE_URL + '/api/tenant/generate-grade-report';
    try {
      return await axios.post('', {
        fromDate: fromDate,
        toDate: toDate,
        selectedUsers: selectedUsers,
        email: email,
        tenantName: tenantName
      }, header(token));
    } catch(Exception) {
      console.log(Exception);
      throw Exception;
    }
  },
  async generateMariaProductivityReport(fromDate, toDate, selectedUsers, email, tenantName, token) {
    axios.defaults.baseURL = process.env.VUE_APP_API_BASE_URL + '/api/tenant/generate-maria-report';
    try {
      return await axios.post('', {
        fromDate: fromDate,
        toDate: toDate,
        selectedUsers: selectedUsers,
        email: email,
        tenantName: tenantName
      }, header(token));
    } catch(Exception) {
      console.log(Exception);
      throw Exception;
    }
  },
  async diagnoseInstance(instanceId, tenantName, token) {
    axios.defaults.baseURL = process.env.VUE_APP_API_BASE_URL + '/api/tenant/diagnose-instance';
    try {
      return await axios.post('', {
        instanceId: instanceId,
        tenantName: tenantName
      }, header(token));
    } catch(Exception) {
      console.log(Exception);
      throw Exception;
    }
  },
  async getCampaigns(type, page, limit, searchQuery, orderQuery, tenantName, token) {
    axios.defaults.baseURL = process.env.VUE_APP_API_BASE_URL + '/api/tenant/get-campaigns';
    try {
      return await axios.post('', {
        type: type,
        page: page,
        limit: limit,
        searchQuery: searchQuery,
        orderQuery: orderQuery,
        tenantName: tenantName
      }, header(token));
    } catch(Exception) {
      console.log(Exception);
      throw Exception;
    }
  },
  async restartCampaign(campaignId, minutes, messages, startAt, finishAt, tenantName, token) {
    axios.defaults.baseURL = process.env.VUE_APP_API_BASE_URL + '/api/tenant/restart-campaign';
    try {
      return await axios.post('', {
        campaignId: campaignId,
        minutes: minutes,
        messages: messages,
        startAt: startAt,
        finishAt: finishAt,
        tenantName: tenantName
      }, header(token));
    } catch(Exception) {
      console.log(Exception);
      throw Exception;
    }
  },
  async getFinishedTicketsRank(from, to, tenantName, token) {
    axios.defaults.baseURL = process.env.VUE_APP_API_BASE_URL + '/api/tenant/get-finished-tickets-rank';
    try {
      return await axios.post('', {
        from: from,
        to: to,
        tenantName: tenantName
      }, header(token));
    } catch(Exception) {
      console.log(Exception);
      throw Exception;
    }
  },
  async undoFinishedTickets(userId, from, to, tenantName, token) {
    axios.defaults.baseURL = process.env.VUE_APP_API_BASE_URL + '/api/tenant/undo-finished-tickets';
    try {
      return await axios.post('', {
        userId: userId,
        from: from,
        to: to,
        tenantName: tenantName
      }, header(token));
    } catch(Exception) {
      console.log(Exception);
      throw Exception;
    }
  },
  async campaignMassOptions(tenantName, token, instanceId = null) {
    axios.defaults.baseURL = process.env.VUE_APP_API_BASE_URL + '/api/tenant/campaign-mass/options';
    try {
      const params = {
        tenantName,
      };

      const parsedInstanceId = Number(instanceId);
      if (!Number.isNaN(parsedInstanceId) && parsedInstanceId > 0) {
        params.instanceId = parsedInstanceId;
      }

      return await axios.get('', {
        params,
        ...header(token)
      });
    } catch (Exception) {
      console.log(Exception);
      throw Exception;
    }
  },
  async campaignMassDryRun(payload, token) {
    axios.defaults.baseURL = process.env.VUE_APP_API_BASE_URL + '/api/tenant/campaign-mass/dry-run';
    try {
      return await axios.post('', payload, header(token));
    } catch (Exception) {
      console.log(Exception);
      throw Exception;
    }
  },
  async campaignMassExecute(batchId, token) {
    axios.defaults.baseURL = process.env.VUE_APP_API_BASE_URL + '/api/tenant/campaign-mass/execute';
    try {
      return await axios.post('', { batchId }, header(token));
    } catch (Exception) {
      console.log(Exception);
      throw Exception;
    }
  },
  async campaignMassHistory(page, limit, status, requestedBy, tenantId, from, to, token) {
    axios.defaults.baseURL = process.env.VUE_APP_API_BASE_URL + '/api/tenant/campaign-mass/history';
    try {
      return await axios.get('', {
        params: {
          page,
          limit,
          status,
          requestedBy,
          tenantId,
          from,
          to,
        },
        ...header(token)
      });
    } catch (Exception) {
      console.log(Exception);
      throw Exception;
    }
  },
  async campaignMassHistoryDetail(batchId, token) {
    axios.defaults.baseURL = process.env.VUE_APP_API_BASE_URL + `/api/tenant/campaign-mass/history/${batchId}`;
    try {
      return await axios.get('', header(token));
    } catch (Exception) {
      console.log(Exception);
      throw Exception;
    }
  },
  async campaignMassRetryFailed(batchId, token) {
    axios.defaults.baseURL = process.env.VUE_APP_API_BASE_URL + `/api/tenant/campaign-mass/history/${batchId}/retry-failed`;
    try {
      return await axios.post('', {}, header(token));
    } catch (Exception) {
      console.log(Exception);
      throw Exception;
    }
  },
  async customerCategoryMassUpload(tenantName, file, sheetsMetadata, token) {
    axios.defaults.baseURL = process.env.VUE_APP_API_BASE_URL + '/api/tenant/customer-category-mass/upload';
    try {
      const formData = new FormData();
      formData.append('tenantName', tenantName);
      formData.append('file', file);
      formData.append('sheetsMetadata', JSON.stringify(sheetsMetadata || []));

      return await axios.post('', formData, {
        headers: {
          ...header(token).headers,
          'Content-Type': 'multipart/form-data',
        },
      });
    } catch (Exception) {
      console.log(Exception);
      throw Exception;
    }
  },
  async customerCategoryMassDryRun(payload, token) {
    axios.defaults.baseURL = process.env.VUE_APP_API_BASE_URL + '/api/tenant/customer-category-mass/dry-run';
    try {
      return await axios.post('', payload, header(token));
    } catch (Exception) {
      console.log(Exception);
      throw Exception;
    }
  },
  async customerCategoryMassExecute(batchId, token) {
    axios.defaults.baseURL = process.env.VUE_APP_API_BASE_URL + '/api/tenant/customer-category-mass/execute';
    try {
      return await axios.post('', { batchId }, header(token));
    } catch (Exception) {
      console.log(Exception);
      throw Exception;
    }
  },
  async customerCategoryMassHistory(page, limit, status, requestedBy, tenantId, from, to, token) {
    axios.defaults.baseURL = process.env.VUE_APP_API_BASE_URL + '/api/tenant/customer-category-mass/history';
    try {
      return await axios.get('', {
        params: {
          page,
          limit,
          status,
          requestedBy,
          tenantId,
          from,
          to,
        },
        ...header(token),
      });
    } catch (Exception) {
      console.log(Exception);
      throw Exception;
    }
  },
  async customerCategoryMassHistoryDetail(batchId, token) {
    axios.defaults.baseURL = process.env.VUE_APP_API_BASE_URL + `/api/tenant/customer-category-mass/history/${batchId}`;
    try {
      return await axios.get('', header(token));
    } catch (Exception) {
      console.log(Exception);
      throw Exception;
    }
  },
  async customerCategoryMassRetryFailed(batchId, token) {
    axios.defaults.baseURL = process.env.VUE_APP_API_BASE_URL + `/api/tenant/customer-category-mass/history/${batchId}/retry-failed`;
    try {
      return await axios.post('', {}, header(token));
    } catch (Exception) {
      console.log(Exception);
      throw Exception;
    }
  },
  async getInstances(tenantName, token) {
    axios.defaults.baseURL = process.env.VUE_APP_API_BASE_URL + '/api/tenant/get-instances';
    try {
      return await axios.get('',  {
        params: {
          tenantName: tenantName
        },
        ...header(token)
      });
    } catch(Exception) {
      console.log(Exception);
      throw Exception;
    }
  },
  async getPartners(token, tenantName) {
    axios.defaults.baseURL = process.env.VUE_APP_API_BASE_URL + '/api/tenant/partners';
    try {
      return await axios.get('',  {
        params: {
          tenantName: tenantName
        },
        ...header(token)
      });
    } catch(Exception) {
      console.log(Exception);
      throw Exception;
    }
  },
  async getTenantChatFlowTemplate(tenantName, flowType, token) {
    axios.defaults.baseURL = process.env.VUE_APP_API_BASE_URL + '/api/tenant/chat-flows/template';
    try {
      return await axios.post('', {
        tenantName: tenantName,
        flowType: flowType
      }, header(token));
    } catch (Exception) {
      console.log(Exception);
      throw Exception;
    }
  },
  async updatePartner(partnerId, tenantName, token) {
    store.dispatch('setShowLoadingOverlay', false);
    axios.defaults.baseURL = process.env.VUE_APP_API_BASE_URL + '/api/tenant/partner';
    try {
      return await axios.post('', {'partner_id': partnerId, 'tenantName': tenantName}, header(token));
    } catch (Exception) {
      throw Exception;
    }
  },
  async replicateTenantChatFlow(
    sourceTenant,
    targetTenants,
    sourceTenantDetails,
    targetTenantDetails,
    flowType,
    includeSchedule,
    authorizationPassword,
    clientIp,
    token,
    timeout = 120000
  ) {
    axios.defaults.baseURL = process.env.VUE_APP_API_BASE_URL + '/api/tenant/chat-flows/replicate';
    try {
      const config = {...header(token)};
      if (timeout !== undefined && timeout !== null) {
        config.timeout = timeout;
      }
      return await axios.post('', {
        source_tenant: sourceTenant,
        target_tenants: targetTenants,
        source_tenant_details: sourceTenantDetails,
        target_tenant_details: targetTenantDetails,
        flow_type: flowType,
        include_schedule: includeSchedule,
        authorization_password: authorizationPassword,
        client_ip: clientIp
      }, config);
    } catch (Exception) {
      console.log(Exception);
      throw Exception;
    }
  },
  async getUsageReport(token, startAt, finishAt, filters = {}, groupBy = null) {
    if (!filters || typeof filters !== 'object' || Array.isArray(filters)) {
      filters = { tenancyId: filters, groupBy };
    }

    const params = new URLSearchParams({ startAt, finishAt });
    if (filters.tenancyId) params.append('tenancyId', filters.tenancyId);
    if (filters.tenantNames && filters.tenantNames.length) params.append('tenantNames', filters.tenantNames.join(','));
    if (filters.hostnameIds && filters.hostnameIds.length) params.append('hostnameIds', filters.hostnameIds.join(','));
    if (filters.hostnameId) params.append('hostnameId', filters.hostnameId);
    if (filters.instanceIds && filters.instanceIds.length) params.append('instanceIds', filters.instanceIds.join(','));
    if (filters.groupBy)   params.append('groupBy', filters.groupBy);
    axios.defaults.baseURL = process.env.VUE_APP_API_BASE_URL + `/api/tenant/usage-report?${params}`;
    try {
      return await axios.get('', header(token));
    } catch (Exception) {
      throw Exception;
    }
  },
  async getTenantChatFlowReplicationLogs(flowType, page = 1, limit = 20, token) {
    axios.defaults.baseURL = process.env.VUE_APP_API_BASE_URL + '/api/tenant/chat-flows/logs';
    try {
      return await axios.get('', {
        params: {
          flow_type: flowType,
          pagination_page: page,
          pagination_limit: limit
        },
        ...header(token)
      });
    } catch (Exception) {
      console.log(Exception);
      throw Exception;
    }
  },
  async getTenantChatFlowReplicationLogById(logId, token) {
    axios.defaults.baseURL = process.env.VUE_APP_API_BASE_URL + '/api/tenant/chat-flows/logs';
    try {
      return await axios.get('', {
        params: { id: logId },
        ...header(token)
      });
    } catch (Exception) {
      console.log(Exception);
      throw Exception;
    }
  },
  async generateTotalAttendancesReport(payload, token) {
    axios.defaults.baseURL = process.env.VUE_APP_API_BASE_URL + '/api/tenant/generate-total-attendances-report';
    const body = {
      fromDate: payload.fromDate,
      toDate: payload.toDate,
      scope: payload.scope,
      segment: payload.segment,
      email: payload.email || '',
      estimation: payload.estimation,
    };
    if (payload.scope === 'specific' && payload.tenantIdentifier) {
      body.tenantIdentifier = String(payload.tenantIdentifier).trim();
    }
    try {
      return await axios.post('', body, header(token));
    } catch (Exception) {
      console.log(Exception);
      throw Exception;
    }
  },
}